import { useRestrictions, useSettings } from '@/app/providers';
import { Lock } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const currency = (amount: number) =>
  new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount);

/**
 * Estado visual del residente en Listado Negro. Es la única pantalla a la que
 * ProtectedRoute redirige, así que también es donde el usuario entiende qué
 * pasó y cómo salir: pagar o contactar a administración.
 */
const CuentaRestringida: React.FC = () => {
  const navigate = useNavigate();
  const { data, refresh } = useRestrictions();
  const { systemSettings } = useSettings();

  const debt = data?.debtAmount ?? 0;
  const supportPhone = systemSettings?.contactPhone;

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-md text-center">
        <span className="mx-auto mb-5 flex h-20 w-20 items-center justify-center rounded-2xl bg-red-100 text-red-600">
          <Lock size={36} />
        </span>

        <h1 className="text-xl font-bold text-theme">Cuenta restringida</h1>
        <p className="mt-2 text-sm text-theme-secondary">
          Tu cuenta tiene restricciones administrativas. Por el momento solo puedes consultar y
          pagar tus adeudos; el resto de los módulos no está disponible.
        </p>

        {debt > 0 && (
          <div className="mt-5 rounded-2xl border border-theme p-4">
            <p className="text-xs text-theme-secondary">Adeudo total</p>
            <p className="mt-0.5 text-2xl font-bold text-theme">{currency(debt)}</p>
          </div>
        )}

        <div className="mt-6 flex flex-col gap-2.5">
          <button
            type="button"
            onClick={() => navigate('/pagos')}
            className="w-full cursor-pointer rounded-xl bg-red-600 px-4 py-3 text-sm font-semibold text-white hover:bg-red-700"
          >
            Ir a pagar
          </button>

          {supportPhone && (
            <a
              href={`tel:${supportPhone}`}
              className="w-full cursor-pointer rounded-xl border border-theme px-4 py-3 text-sm font-semibold text-theme hover:bg-surface-secondary"
            >
              Contactar administración
            </a>
          )}

          <button
            type="button"
            onClick={() => void refresh()}
            className="cursor-pointer py-2 text-xs font-medium text-theme-secondary hover:underline"
          >
            Ya pagué, actualizar estado
          </button>
        </div>
      </div>
    </div>
  );
};

export default CuentaRestringida;
